import { ButtonIconPermissioned } from "components/ButtonIconPermissioned/ButtonIconPermissioned";
import {
  ModalArchiveDrsFile,
  ModalArchiveDrsFileProps,
} from "components/ModalArchiveDrsFile/ModalArchiveDrsFile";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import { useState } from "react";
import { getDrsFileModifyPermissionByDrsFileAndAction } from "types/DrsFileModifyPermissions";

export interface ButtonArchiveDrsFileProps {
  drsFile: Parameters<typeof getDrsFileModifyPermissionByDrsFileAndAction>[0] &
    ModalArchiveDrsFileProps["drsFiles"][number];
}

export const ButtonArchiveDrsFile = ({
  drsFile,
}: ButtonArchiveDrsFileProps) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const isViewingHistory = useRouteMapContext(
    (s) =>
      s.isRouteMatch(s.routeMap.DATASET_HISTORY.parameterizedPath) ||
      s.isRouteMatch(s.routeMap.DATASET_VERSION.parameterizedPath),
  );

  return (
    <>
      <ButtonIconPermissioned
        aria-label="Archive file"
        defaultTooltip={
          isViewingHistory
            ? "Archive disabled while viewing history"
            : "Archive file"
        }
        color="primary"
        iconType="snowflake"
        isDisabled={
          isViewingHistory ||
          !getDrsFileModifyPermissionByDrsFileAndAction(drsFile, "ARCHIVE")
            .isPermitted
        }
        onClick={() => {
          setShowConfirmModal(true);
        }}
        requiredPermission="edit"
      />
      {showConfirmModal && (
        <ModalArchiveDrsFile
          drsFiles={[drsFile]}
          onClose={() => setShowConfirmModal(false)}
        />
      )}
    </>
  );
};
